import React from "react";
import Box from '@mui/material/Box';
import { Typography } from "@mui/material";
import ContentPic from "../ContentPic";

const MobileSlider = (props) => {
    const { 
        alt,
        image, 
        title, 
        link,
        isExternal,
        openLatest,
    } = props;

    return (
        <Box 
            sx={{
                width: '100%',
                display: {
                    xs: 'flex',
                    md: 'none'
                },
                flexDirection: 'column', 
                alignItems: 'center',    
                justifyContent: 'center', 
            }}
        >
            <Typography 
                underline="none" 
                color="var(--contra-background-color)"
                align='center'
                sx={{ 
                    fontWeight: 'bold',
                    paddingBottom: '2.5vw', 
                    lineHeight: '1',
                }}
            >
                {title}
            </Typography> 
            <ContentPic 
                alt={alt} 
                image={image} 
                isMobile={true} 
                link={link} 
                isExternal={isExternal}
                openLatest={openLatest}
            />
        </Box>
    );
};

export default MobileSlider;